/**
 * 平台运行时纯净真实数据状态入口（已彻底去除所有 mock 数据种子）。
 */
import {
  ROLE_NAV,
  ROLE_PERMS,
  NAV_LABELS,
  resolveMergedRoleNav,
  resolveMergedRolePerms,
  ALL_NAV_ORDER,
} from './authConfig';

export {
  ROLE_NAV,
  ROLE_PERMS,
  NAV_LABELS,
  resolveMergedRoleNav,
  resolveMergedRolePerms,
  ALL_NAV_ORDER,
};

export function createPlatformData() {
  return {
    stores: [],
    users: {},
    printConfig: {
      global: { bleedMm: 2, cmykProfile: 'FOGRA39' },
      stores: {},
    },
    defaultSongName: '',
    materials: [],
    materialFolders: {},
    templateFolders: {},
    commonColors: {
      global: [],
      stores: {},
      _meta: { globalPaletteId: null, storePaletteIds: {} },
    },
    templates: [],
    designs: [],
    designTasks: [],
    taskStatusMeta: {},
    standaloneDesigns: [],
    logs: [],
    _meta: {
      settings: {},
    },
  };
}

export function ensureDefaultMaterials() {}
export function ensureDefaultTemplates() {}

export function repairMissingMaterialPreviews(data) {
  if (!Array.isArray(data?.materials)) return 0;
  let repaired = 0;
  data.materials.forEach(m => {
    if (!m) return;
    const url = String(m.url || m.originUrl || '').trim();
    const thumb = String(m.thumb || m.thumbUrl || '').trim();
    if (url) {
      if (!thumb) m.thumb = url;
      return;
    }
    if (thumb) {
      m.url = thumb;
      return;
    }
    repaired += 1;
  });
  return repaired;
}

export function isDefaultMaterialId() {
  return false;
}
